var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader2 = function SvgLoader2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 47.9998C83.9996 55.6022 81.5925 63.0093 77.1237 69.1595C72.6549 75.3098 66.3538 79.8874 59.1235 82.2364C51.8932 84.5855 44.1048 84.5852 36.8746 82.2358C29.6444 79.8864 23.3435 75.3084 18.8751 69.1579C14.4066 63.0074 11.9999 55.6001 12 47.9978C12.0001 40.3954 14.4068 32.9882 18.8754 26.8378C23.3439 20.6874 29.6448 16.1094 36.8751 13.7601C44.1053 11.4108 51.8937 11.4107 59.124 13.7598",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLoader2;